import React, { useContext, useState, memo, useCallback, useMemo } from "react";
import CalendarLayout from "./CalenderLayout";
import "./WeekView.css";
import Modal from "../../../../components/controls/modal/Modal";
import ResourceDetailView from "./ResourceDetailView";
import { ResourcePlannerContext } from "../ResourcePlannerContext";

const HourlyView = memo(({ formBody, dashboard }) => {
  const {
    useDetails,
    calendarHeader,
    calendarData,
    detail,
    setDetail,
  } = useContext(ResourcePlannerContext);
  
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [headerValue, setHeaderValue] = useState("");

  const handleCancel = useCallback(() => {
    setShowDetailModal(false);
  }, []);

  const handleClick = useCallback((value) => {
    setShowDetailModal(value);
  }, []);

  // Memoize the formatted header value
  const formattedHeaderValue = useMemo(() => {
    if (!headerValue) return "";
    return headerValue.replace(
      headerValue.split(" ")[1],
      headerValue.split(" ")[1].slice(0, 3)
    );
  }, [headerValue]);

  return (
    <React.Fragment>
      {showDetailModal && (
        <Modal
          title="Resource Details"
          handleCancel={handleCancel}
          handleSave={handleCancel}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          isLoading={false}
          size="large"
          calendarModalWrap={true}
          body={
            <ResourceDetailView
              formBody={formBody}
              title={"hour"}
              label={formattedHeaderValue}
              userDetails={useDetails[detail?.userIndex]}
              shift={detail.shift}
            />
          }
        />
      )}
      <CalendarLayout
        dashboard={dashboard}
        userData={useDetails}
        calendarData={calendarData}
        headerDate={calendarHeader}
        handleClick={handleClick}
        type={true}
      />
    </React.Fragment>
  );
});

HourlyView.displayName = 'HourlyView';

export default HourlyView;
